export default __webpack_public_path__ + "static/media/Air_Costa_Logo.983caad4.jpg";